import { useCallback, useEffect, useState } from 'react'
import { History, RefreshCcw, Search, ShieldCheck } from 'lucide-react'
import { supabase } from '../lib/supabase'
import { CashSafetyMonitor } from '../components/CashSafetyMonitor'

type AuditEvent={
  event_at:string
  category:string
  table_number:number|null
  details:string
  actor_name:string
  order_number:number|null
}

export function TableAudit(){
  const [days,setDays]=useState('7')
  const [tableNumber,setTableNumber]=useState('')
  const [rows,setRows]=useState<AuditEvent[]>([])
  const [loading,setLoading]=useState(false)
  const [error,setError]=useState('')
  const reload=useCallback(async()=>{
    const trimmed=tableNumber.trim()
    const number=trimmed===''?null:Number(trimmed)
    if(number!==null&&(!Number.isInteger(number)||number<1)){
      setError('Informe um número de mesa válido.');return
    }
    setLoading(true);setError('')
    try{
      const {data,error:rpcError}=await supabase.rpc('get_table_audit_events',{
        p_days:Number(days),p_table_number:number
      })
      if(rpcError)throw rpcError
      setRows((data||[]) as AuditEvent[])
    }catch(err){
      setError(err instanceof Error?err.message:'Não foi possível consultar o histórico.')
    }finally{setLoading(false)}
  },[days,tableNumber])

  useEffect(()=>{void reload()},[reload])

  return <>
    <div className="page-heading">
      <div><span className="eyebrow dark">SEGURANÇA DO CAIXA</span>
      <h1>Auditoria de mesas</h1>
      <p>Histórico de lançamentos, mudanças de mesa, transferências e solicitações de cancelamento.</p></div>
      <div className="page-heading-actions"><button className="secondary-button" type="button" onClick={()=>void reload()} disabled={loading}><RefreshCcw size={18}/>{loading?'Consultando…':'Atualizar'}</button></div>
    </div>
    <CashSafetyMonitor/>
    <article className="panel" style={{marginBottom:18}}>
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:15}}><ShieldCheck size={22}/><strong>Consulta somente leitura — acesso restrito à gestão</strong></div>
      <div className="admin-filter-bar">
        <label>Período<select value={days} onChange={e=>setDays(e.target.value)}>
          <option value="1">Últimas 24 horas</option><option value="7">Últimos 7 dias</option><option value="30">Últimos 30 dias</option><option value="90">Últimos 90 dias</option>
        </select></label>
        <label>Número da mesa<input type="number" min="1" placeholder="Todas as mesas" value={tableNumber} onChange={e=>setTableNumber(e.target.value)}/></label>
        <button className="primary-button" type="button" onClick={()=>void reload()} disabled={loading}><Search size={17}/> Consultar</button>
      </div>
      <small>Até 500 eventos mais recentes. O rastreamento automático da mesa de origem começou quando a auditoria foi instalada; lançamentos anteriores podem não ter o registro de origem.</small>
    </article>
    {error&&<div className="form-error" role="alert">{error}</div>}
    <article className="panel">
      <div className="panel-heading"><div><span className="eyebrow dark">RASTREABILIDADE</span><h3>{loading?'Carregando…':rows.length+' eventos encontrados'}</h3></div><History size={22}/></div>
      {!loading&&!rows.length&&!error&&<div className="empty-state compact"><History size={32}/><strong>Nenhum registro no filtro</strong><p>Tente outro período ou mesa.</p></div>}
      <div style={{display:'grid',gap:10}}>
        {rows.map((row,index)=><div key={row.event_at+'-'+row.category+'-'+index} style={{borderBottom:'1px solid var(--border, #e5e7eb)',padding:'10px 0'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,flexWrap:'wrap'}}>
            <strong>{row.category}</strong>
            <small>{new Date(row.event_at).toLocaleString('pt-BR',{dateStyle:'short',timeStyle:'short'})}</small>
          </div>
          <div style={{marginTop:4,overflowWrap:'anywhere'}}>{row.details}</div>
          <small>{row.table_number!=null?'Mesa '+row.table_number+' · ':''}Responsável: {row.actor_name||'Não identificado'}</small>
        </div>)}
      </div>
    </article>
  </>
}
